import { useEffect, useState } from "react";
import { API, getApiKey, urlBase } from "../APICalls";

export default function FileUploader({onFileUploadDone}){


    const [isSelectedFile, setIsSelectedFile] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadedPercentage, setUploadedPercentage] = useState(0);
    

    const onSelectedFile = (evt) => {
        var file = evt.target.files[0];
        
        setSelectedFile(null);
        setIsSelectedFile(false);
        setUploadedPercentage(0);

        if(file != null)
        {
            setSelectedFile(file);
            setIsSelectedFile(true);

            // MANAGE UPLOAD

            var formdata = new FormData();
            formdata.append(file.name, file);

            var xhr = new XMLHttpRequest();
            xhr.open("POST", urlBase + '/api/File');

            xhr.setRequestHeader("Authorization", getApiKey());

            xhr.upload.addEventListener('progress', function(evt) {

                // Update percentage
                var percentageLoaded = Math.floor((evt.loaded/evt.total) * 100);
                setUploadedPercentage(percentageLoaded);

            });

            xhr.onreadystatechange = function() {
                if (xhr.readyState == XMLHttpRequest.DONE) {
                    onFileUploadDone(JSON.parse(xhr.response));
                }
            }



            xhr.send(formdata);
        }
    };

    return (

        <>
            <p>Ficheros de máximo 200MB</p>
            <span class="btn btn-success fileinput-button" onClick={() => {document.querySelector('#fileupload').click()}}>
                <i class="glyphicon glyphicon-plus"></i>
                <span>Selecciona archivos...</span>
                <input id="fileupload" type="file" name="fileupload" hidden onChange={onSelectedFile} />
            </span>

            <br />
            <br />
            
            {isSelectedFile ? (
                <>
                    <div id="progressFileUpload" className="progress">
                        <div class="progress-bar progress-bar-success" style={{width: uploadedPercentage + '%'}}></div>
                    </div>
                    <div id="pnlFileUploadContainer" className="files">
                        <p>{selectedFile.name}</p>
                    </div>
                </>
            ) : (
                <></>
            )}
        </>

    );

}